// Recurring monthly giving — donor mandates and cycle-by-cycle receipts.
// Frontend sample data, drop-in ready for a real gateway subscription API.

export type MandateStatus = "Active" | "Paused" | "Cancelled" | "Mandate failed";
export type CycleStatus = "Paid" | "Upcoming" | "Failed" | "Skipped";

export type MandateCycle = {
  cycle: number;
  month: string;
  date: string;
  amount: number;
  status: CycleStatus;
  receiptId?: string;
  note?: string;
};

export type Mandate = {
  id: string;
  programId: string;
  programTitle: string;
  orgId: string;
  orgName: string;
  domain: string;
  impact: string;
  amount: number;
  status: MandateStatus;
  startedOn: string;
  nextDebit: string;
  method: string;
  mandateRef: string;
  cycles: MandateCycle[];
};

function cyclesFrom(amount: number, months: string[], paidUpto: number, failedAt?: number): MandateCycle[] {
  return months.map((m, i) => {
    const n = i + 1;
    if (failedAt === n) return { cycle: n, month: m, date: `05 ${m}`, amount, status: "Failed", note: "Bank declined — insufficient balance" };
    if (n <= paidUpto) return { cycle: n, month: m, date: `05 ${m}`, amount, status: "Paid", receiptId: `RC-${1000 + n}-${Math.round(amount / 100)}` };
    return { cycle: n, month: m, date: `05 ${m}`, amount, status: "Upcoming" };
  });
}

const months2026 = ["Jan 2026", "Feb 2026", "Mar 2026", "Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"];

export const mandates: Mandate[] = [
  {
    id: "MD-4411",
    programId: "pg-fodder",
    programTitle: "Daily fodder seva",
    orgId: "",
    orgName: "Shree Ahmedabad Panjrapole",
    domain: "animal-seva",
    impact: "Feeds 5 cattle every day for a month",
    amount: 2100,
    status: "Active",
    startedOn: "05 Jan 2026",
    nextDebit: "05 Aug 2026",
    method: "UPI AutoPay · HDFC ••4471",
    mandateRef: "UPI/AUTOPAY/DA4411",
    cycles: cyclesFrom(2100, months2026, 7),
  },
  {
    id: "MD-4392",
    programId: "pg-child",
    programTitle: "Sponsor a child's learning",
    orgId: "vidya-setu-foundation",
    orgName: "Vidya Setu Foundation",
    domain: "shiksha-daan",
    impact: "One child's tuition, kit and meals for a month",
    amount: 1500,
    status: "Active",
    startedOn: "05 Feb 2026",
    nextDebit: "05 Aug 2026",
    method: "e-NACH · ICICI ••9820",
    mandateRef: "NACH/ICIC/DA4392",
    cycles: cyclesFrom(1500, months2026.slice(1), 5, 4),
  },
  {
    id: "MD-4310",
    programId: "pg-meals",
    programTitle: "Daily meals seva",
    orgId: "annapurna-seva-mandal",
    orgName: "Annapurna Seva Mandal",
    domain: "anna-daan",
    impact: "Serves 30 hot meals every month",
    amount: 900,
    status: "Paused",
    startedOn: "05 Jan 2026",
    nextDebit: "Paused",
    method: "Card mandate · Visa ••3312",
    mandateRef: "CARD/MND/DA4310",
    cycles: cyclesFrom(900, months2026.slice(0, 5), 4),
  },
];

export function mandateTotals(m: Mandate) {
  const paid = m.cycles.filter((c) => c.status === "Paid");
  return {
    paidCycles: paid.length,
    contributed: paid.reduce((s, c) => s + c.amount, 0),
    failed: m.cycles.filter((c) => c.status === "Failed").length,
  };
}